// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3OAG5","bigColWidth":"Table_bigColWidth__3dQDY","biggerColWidth":"Table_biggerColWidth__2tqjA","row":"Table_row__2ml-h","col":"Table_col__2OsM_"};